module.exports = __webpack_public_path__ + "img/HelveticaNeueCyrMedium.951986a.svg";